import { render, staticRenderFns } from "./TicketReview.vue?vue&type=template&id=0a7e9d39&"
import script from "./TicketReview.vue?vue&type=script&lang=ts&"
export * from "./TicketReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports